import decode, { JwtPayload } from 'jwt-decode';

/**
 * Only parses, does not validate signature.
 */
export function jwtDecode<Payload extends JwtPayload = JwtPayload>(token?: string): Payload | null {
  try {
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    return decode<Payload>(token);
  } catch {
    return null;
  }
}
